import common from '@/sui/sc/helps/common'

export default [
  common.disciplines,
  {
    title: `Porte d'entrées`,
    list: [
      { t: 'Cathéters', f: `$pe ~ "C|D1"` }
    ]
  }
]
